import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { DefaultImageModule } from '~shared/directives/default-image/default-image.module';
import { LazyLoadImageModule } from '~shared/directives/lazyload/lazy-load-image.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmIconModule } from '@metromarkets/components';
import {
    CategoryFacetsCarouselComponent
} from '~shared/components/category-facets-carousel/category-facets-carousel.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        DefaultImageModule,
        LazyLoadImageModule,
        CarouselModule,
        QaLocatorsModule,
        MmIconModule,
    ],
  declarations: [CategoryFacetsCarouselComponent],
  exports: [CategoryFacetsCarouselComponent],
})
export class CategoryFacetsCarouselModule {}
